import { useMaterialUIController } from "context";

export const surfaceSx = ({ palette, borders, functions: { rgba } }) => ({
  backgroundColor: palette.background?.card || "#1a2035",
  border: `1px solid ${rgba(palette.text.main, 0.12)}`,
  borderRadius: borders.borderRadius.lg,
  boxShadow: "none",
});

export const nestedSurfaceSx = ({ palette, borders, functions: { rgba } }) => ({
  backgroundColor: rgba(palette.text.main, 0.035),
  border: `1px solid ${rgba(palette.text.main, 0.10)}`,
  borderRadius: borders.borderRadius.md,
  boxShadow: "none",
});

export const chipSx = {
  height: 24,
  borderRadius: "6px",
  fontWeight: 700,
  "& .MuiChip-label": { px: 1 },
};

export const TONES = {
  pick: { color: "info", icon: "fa-solid fa-arrow-down", title: "Picking up", pulse: true },
  drop: { color: "primary", icon: "fa-solid fa-arrow-up", title: "Dropping off", pulse: true },
  open: { color: "warning", icon: "fa-solid fa-hourglass-half", title: "Capture open" },
  saving: { color: "warning", icon: "fa-solid fa-floppy-disk", title: "Saving transfer" },
  saved: { color: "success", icon: "fa-solid fa-circle-check", title: "Transfer saved" },
  unlogged: { color: "error", icon: "fa-solid fa-user-secret", title: "Level changed without a capture" },
  offline: { color: "error", icon: "fa-solid fa-tower-broadcast", title: "No signal" },
  idle: { color: "secondary", icon: "fa-solid fa-circle-pause", title: "Ready" },
};

export const TYPE_META = {
  pick: { color: "info", icon: "fa-solid fa-arrow-down", label: "Pick" },
  drop: { color: "primary", icon: "fa-solid fa-arrow-up", label: "Drop" },
  no_change: { color: "secondary", icon: "fa-solid fa-equals", label: "No change" },
};

// The page hardcodes "white" today; this keeps values readable if light mode is used.
export function useValueColor() {
  const [controller] = useMaterialUIController();
  return controller?.darkMode === false ? "dark" : "white";
}
